<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <template v-if="user.loggedIn">
         <v-toolbar-title>Welcome {{ this.$store.getters.user.data.displayName }} </v-toolbar-title> 
      </template>
      <template v-else>
      <v-toolbar-title>Welcome</v-toolbar-title>
      </template>
      <v-spacer></v-spacer>
      <v-btn text rounded to="/">Txtr.app</v-btn>
      <template v-if="this.$store.getters.user.loggedIn">
        <v-btn  text rounded to="/dashboard">dashboard</v-btn>
        <v-btn @click="logout" text rounded>
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </template>
      <template v-else>
        <v-btn  text rounded to="/login">Login</v-btn>
        <v-btn  text rounded to="/register">Register</v-btn>
      </template>

      <v-btn  text rounded to="/pricing">
        <v-icon>mdi-currency-usd</v-icon>
      </v-btn>
      <v-btn @click="toggleTheme" text rounded>
        <v-icon>mdi-invert-colors</v-icon>
      </v-btn>
    </v-app-bar>
    <v-content>
      <router-view></router-view>
    </v-content>
    <v-footer color="primary lighten-1" padless>
      <v-layout justify-center wrap>
        <v-flex primary lighten-2 py-4 text-center white--text xs12>
          {{ new Date().getFullYear() }} — <strong>Txtr.app: Like Mailchimp, but for texting.</strong>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from "vuex"
import firebase from 'firebase'
// import user from './store.js'

export default {
  name: 'App',
  methods: {
    logout() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          this.$router.replace({
            name: "home"
          });
        });
    },
    toggleTheme() {
      this.$vuetify.theme.themes.dark.anchor = '#41B883'
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
    }
  },
  computed: {
    // map `this.user` to `this.$store.getters.user`
    ...mapGetters({
      user: "user"
    })
  }
}
</script>
